module.exports = __webpack_public_path__ + "fonts/EurostileBold.7548775.woff";